/**
 * Tail of the chain of cart mutations this widget sends to the host.
 *
 * Shared by both transports: the direct posts in apis/cartWebSocketClient.js and the postMessage requests in
 * util/postMessageHandshake.js. Mutations reach a cart held by the server, so letting them overlap loses a seat.
 * Chaining them keeps them in the order the operator clicked and stops them from overlapping.
 */
let pendingCartMutation = Promise.resolve();

/**
 * Runs a cart mutation after every mutation queued before it has settled.
 *
 * @param {Function} mutation Function performing the request.
 * @returns {Promise} The mutation's own result.
 */
export const queueCartMutation = (mutation) => {
	const result = pendingCartMutation.then(mutation, mutation);
	// Swallowed on the chain only: a rejected mutation must not stop the ones queued behind it. The caller still
	// receives the original promise, rejection included.
	pendingCartMutation = result.then(
		() => undefined,
		() => undefined,
	);
	return result;
};

/** Test-only: resets the chain so tests don't leak state into each other. */
export const resetCartMutationQueue = () => {
	pendingCartMutation = Promise.resolve();
};
